import { hubSpotConnectRedirect } from './productLinks';
import { getHublet, getIsNewUser } from '../store/app/selectors';
export const getConnectFlowRedirect = state => {
  const isNewUser = getIsNewUser(state);
  const hublet = getHublet(state);
  return hubSpotConnectRedirect({
    hublet,
    isNewUser
  });
};